<div tabindex="0" class="flex items-center justify-center w-full p-1 h-7" (click)="clickEvent.emit()" (keydown)="(null)" >
  <div class="flex items-center w-full h-full space-x-1">
    <nrc-country-icon
      [ngClass]="iconClassList"
      [code]="countryCode ?? ''"
    />
    <span [ngClass]="textClassList" class="text-sm font-light"> {{ name }} </span>
  </div>
</div>
